import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

@InjectModule({ stateFactory: true }, module)
export default class PathModule extends InjectVuexModule {
    path = '';

    @Mutation
    setPath(path:'patient' | 'caregiver') {
        this.path = path;
    }
}
